import spellWorkerUrl from './spellCheckerWorker?worker&url';

let spellCheckerWorker: Worker | null = null;
const spellCheckerCallbacks: Record<
  number,
  (isCorrect: boolean, suggestions: string[]) => void
> = {};
let spellCheckerWorkerCommandId = 0;
let workerReadyPromise: Promise<void> | null = null;

function initializeWorker() {
  if (workerReadyPromise) return workerReadyPromise;

  workerReadyPromise = new Promise<void>((resolve) => {
    spellCheckerWorker = new Worker(spellWorkerUrl, { type: 'module' });

    spellCheckerWorker.onerror = (err) => {
      console.error('[SpellChecker] Error:', err);
    };

    spellCheckerWorker.onmessage = (e) => {
      const { command, id, isCorrect, suggestions } = e.data;

      if (command === 'ready') {
        resolve();
        return;
      }

      const callback = spellCheckerCallbacks[id];
      if (callback) {
        delete spellCheckerCallbacks[id];
        callback(isCorrect, suggestions || []);
      }
    };

    spellCheckerWorker.postMessage({ command: 'init' });
  });

  workerReadyPromise.then(() => {
    const myDictionary: string[] = JSON.parse(
      localStorage.getItem('myDictionary') || '[]',
    );
    myDictionary.forEach((word) => {
      spellCheckerWorker!.postMessage({ command: 'addWord', word });
    });
  });

  return workerReadyPromise;
}

export const checkWordSpelling = async (
  word: string,
  callback: (isCorrect: boolean, suggestions: string[]) => void,
) => {
  await initializeWorker();
  const id = spellCheckerWorkerCommandId++;
  spellCheckerCallbacks[id] = callback;
  spellCheckerWorker!.postMessage({ command: 'checkWord', word, id });
};

export const addWordToDictionary = async (word: string) => {
  await initializeWorker();
  const myDictionary = new Set(
    JSON.parse(localStorage.getItem('myDictionary') || '[]'),
  );
  myDictionary.add(word);
  localStorage.setItem('myDictionary', JSON.stringify([...myDictionary]));
  spellCheckerWorker!.postMessage({ command: 'addWord', word });
};
